module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "two-line": "",
      "avatar": ""
    }
  }, [_c('v-subheader', [_vm._v("Become someone else")]), _vm._v(" "), _vm._l((_vm.becomeUsers), function(user) {
    return [_c('v-list-tile', {
      key: ("user=" + (user.id))
    }, [_c('v-list-tile-avatar', [(user.profile) ? _c('img', {
      attrs: {
        "src": user.profile
      }
    }) : _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v(_vm._s(user.full_name))]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.login(user.id)
        }
      }
    }, [_vm._v("Become")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: user.id
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58bee45f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Become.vue
// module id = 1661
// module chunks = 1